// extracted by mini-css-extract-plugin
export var list = "styles-module__list___REyyu";
export var button = "styles-module__button___HGGnq";
export var active = "styles-module__active___T5oaa";
export var big = "styles-module__big___ts7BT";